import React from 'react'
import DefaultLayout from '../DefaultLayout'

const FeaturesWrapper = () => {
    const items = [
        { title: '睡眠の質', subtitle: "", imgSrc: "/feature_1.png" },
        { title: '体温', subtitle: "表皮体温", imgSrc: "/feature_2.png" },
        { title: '歩数', subtitle: "", imgSrc: "/feature_3.png" },
        { title: '消費カロリー', subtitle: "", imgSrc: "/feature_4.png" },
        { title: '脈拍数', subtitle: "", imgSrc: "/feature_5.png" },
        { title: '血中酸素飽和度', subtitle: "Sp02", imgSrc: "/feature_6.png" },
        { title: 'HRV', subtitle: "心拍変動", imgSrc: "/feature_7.png" },
        { title: 'PR間隔等', subtitle: "心拍間隔", imgSrc: "/feature_8.png" },
        { title: '呼吸数', subtitle: "", imgSrc: "/feature_9.png" },
    ]
    return (
        <div className='py-20 bg-main-600 text-white'>
            <DefaultLayout className='px-6'>
                <>
                    <h2 className='text-center text-2xl font-semibold mb-10 text-main-100'>
                        計測可能項目
                    </h2>

                    <div className='grid grid-cols-2 sm:grid-cols-4 gap-4'>
                        {items.map((item, index) => (
                            <div key={index} className='flex flex-col items-center rounded-xl pt-4 border border-main-200 bg-white'>
                                <img className='w-24 sm:w-32 h-24 sm:h-32 mb-4' src={"https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp/" + item.imgSrc} alt={item.title} width={600} height={600} />
                                <div className='flex flex-col lg:flex-row text-main-600 mb-4 text-center'>
                                    <h3 className='text-base sm:text-xl font-semibold sm:leading-10'>
                                        {item.title}
                                    </h3>
                                    {item.subtitle && <p className='sm:leading-10'>（{item.subtitle}）</p>}
                                </div>
                            </div>
                        ))}
                    </div>

                </>
            </DefaultLayout>
        </div>
    )
}

export default FeaturesWrapper